module.exports = __webpack_public_path__ + "static/media/team-1.1e388f3b.png";